// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ButtonLoadMore_wrapper__w8sM4","show-more-button":"ButtonLoadMore_show-more-button__FXKXn","spin":"ButtonLoadMore_spin__e15kw"};